// extracted by mini-css-extract-plugin
export default {"zoomModal":"B3-z","image":"C3-z","button":"D3-z","isOverlayShown":"E3-z"};